import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, SearchIcon, ShoppingCartIcon, MenuIcon } from 'lucide-react';
import { MobileSearchOverlay } from '../shared/MobileSearchOverlay';
import { useStore } from '../../lib/store';
interface MobileInternalHeaderProps {
  title: string;
  showActions?: boolean;
  showMenu?: boolean;
  onMenuClick?: () => void;
}
export function MobileInternalHeader({
  title,
  showActions = true,
  showMenu = false,
  onMenuClick
}: MobileInternalHeaderProps) {
  const navigate = useNavigate();
  const cartCount = useStore(state => state.cartCount());
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  return <>
      <header className="md:hidden fixed top-0 left-0 right-0 h-14 bg-white border-b border-gray-100 z-50 flex items-center px-4 safe-area-top" data-id="element-2531" data-mp="105iauvkuaesa">
      {/* Back Button */}
      <button type="button" onClick={() => navigate(-1)} aria-label="Go back" className="p-2 -ml-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" data-id="element-2532" data-mp="31wlm9n2jzxdw">
        <ChevronLeftIcon className="w-6 h-6" data-id="element-2533" data-mp="18yxw6z1i9yyr" />
      </button>

      {/* Title */}
      <h1 className="flex-1 text-base font-bold text-gray-900 truncate ml-2" data-id="element-2534" data-mp="142ft03ltq8oj">
        {title}
      </h1>

      {/* Actions */}
      {showActions && <div className="flex items-center gap-1" data-id="element-2535" data-mp="1wr4zki5nf67o">
          <button type="button" onClick={() => setIsSearchOpen(true)} className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Search" data-id="element-2536" data-mp="1wptw6jg480h3">
            <SearchIcon className="w-5 h-5" data-id="element-2537" data-mp="1ht2we92j4mqy" />
          </button>

          <button type="button" onClick={() => navigate('/cart')} className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors relative focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Cart" data-id="element-2538" data-mp="bebmjfvfhrks">
            <ShoppingCartIcon className="w-5 h-5" data-id="element-2539" data-mp="2ykerqy6etgfs" />
            {cartCount > 0 && <span className="absolute top-1 right-1 bg-red-500 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center border border-white" data-id="element-2540" data-mp="2kmq5blwp218m">
                {cartCount}
              </span>}
          </button>

          {showMenu && <button type="button" onClick={onMenuClick ?? (() => navigate('/menu'))} className="p-2 text-gray-700 active:bg-gray-50 rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand" aria-label="Menu" data-id="element-2541" data-mp="2fmu2hpzqgfun">
            <MenuIcon className="w-5 h-5" data-id="element-2542" data-mp="1rwrcrgjajlz7" />
          </button>}
        </div>}
      </header>
      <MobileSearchOverlay isOpen={isSearchOpen} onClose={() => setIsSearchOpen(false)} data-id="element-2543" data-mp="1wwvuf9vxqmr0" />
    </>;
}